import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicCommentsService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public createComment(
    text: string,
    commentable_type: string,
    commentable_id: string | number,
    type: string = undefined,
    document_id?: number | null
  ): Observable<any> {
    const body: Record<string, unknown> = {
      text,
      commentable_type,
      commentable_id,
      type,
    };
    if (document_id != null) {
      body["document_id"] = document_id;
    }
    return this.publicHttp
      .post("/api/comments", body)
      .pipe(tap((_) => console.log("PublicCommentsService.createComment: Ok.")));
  }
}
